import { MediaServerURL } from "../config/Site"

export const productPictureURL = (product, size=180) =>
    MediaServerURL(`/images/products/${size}/${product.picture_uri}`)

